import React from 'react';

const EventRefundPolicy = () => (
  <div className='eventDetailsRefundPolicy__wrapper'>
    <h3 className='t-paragraph--bold'>Refund Policy</h3>
    <p>
      Free events may be cancelled by registrants at any time in WakeNetwork. If
      you have questions about registrations for paid events, please reach out
      to the event contact.
    </p>
  </div>
);

export default EventRefundPolicy;
